import {
  faCheck,
  faClipboardCheck,
  faDash,
  faHand,
  faPaperPlaneTop,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import { StatusListingColors } from '@labrav/react-components'

import { ProductStatus } from '../../modules/productsListing/types'
import type { StatusListingResObj } from '../../types/addEditProduct'

export const getStatusListingData = (
  auditJson: StatusListingResObj,
  currentStatus: string
) => {
  return Object.entries(auditJson).map(([status, completed]) => {
    let icon
    let color = StatusListingColors.GREY
    let background = StatusListingColors.WHITE
    let display = true
    let sortOrder = 0
    let tooltipText = ''
    switch (status) {
      case ProductStatus.PRODUCT_STATUS_DRAFT:
        icon = faCheck
        color = StatusListingColors.WHITE
        background = StatusListingColors.COMPLETED
        sortOrder = 1
        tooltipText = 'Your listing is in draft state.'
        break
      case ProductStatus.PRODUCT_STATUS_LIMITED:
        icon = faHand
        background = StatusListingColors.LIMITED
        sortOrder = 2
        tooltipText =
          'Labra will fetch and subscribe to certain listing attributes which will help you in managing your listing.'
        break
      case ProductStatus.PRODUCT_STATUS_LABRA_TESTING:
        icon = faClipboardCheck
        sortOrder = 3
        tooltipText =
          'Labra will test the end-to-end buyer flow for your listing and submit it for publishing to AWS Marketplace.'
        break
      case ProductStatus.PRODUCT_STATUS_AWS_TESTING:
        icon = faClipboardCheck
        sortOrder = 4
        tooltipText =
          'AWS Marketplace team will test end-to-end buyer flow for listing and either accept or reject the listing.'
        break
      case ProductStatus.PRODUCT_STATUS_PUBLIC:
        icon = faPaperPlaneTop
        sortOrder = 5
        tooltipText = 'Listing is live on the marketplace, no action required.'
        break
      case ProductStatus.PRODUCT_STATUS_REJECTED:
        icon = faXmark
        background = StatusListingColors.REJECTED
        color = StatusListingColors.WHITE
        sortOrder = 6
        tooltipText =
          'You need to change listing information according to reason cited for rejection from AWS Marketplace team after AWS testing.'
        break
      case ProductStatus.PRODUCT_STATUS_RESTRICTED:
        icon = faDash
        background = StatusListingColors.RESTRICTED
        color = StatusListingColors.WHITE
        sortOrder = 6
        tooltipText =
          'You can choose to make the listing public on AWS marketplace again.'
        break
      default:
        icon = faClipboardCheck
        display = false
    }
    const updatedCompeletd =
      currentStatus === status &&
      ['Limited', 'Labra-testing', 'AWS-testing'].includes(currentStatus)
        ? ''
        : completed
    return {
      status,
      completed: updatedCompeletd,
      icon,
      color,
      background,
      display,
      sortOrder,
      tooltipText,
    }
  })
}
